import {
  LWWRegister,
  mergeLWWRegister,
  stampRegister,
  Timestamp,
} from "./lwwRegister.js";

export type LWWMap = Record<string, LWWRegister<unknown>>;

export function mergeLWWMap(
  local: LWWMap | undefined,
  remote: LWWMap | undefined,
): LWWMap {
  const merged: LWWMap = { ...(local ?? {}) };
  for (const [key, remoteReg] of Object.entries(remote ?? {})) {
    merged[key] = mergeLWWRegister(merged[key], remoteReg)!;
  }
  return merged;
}

export function setLWWMapValue(
  map: LWWMap,
  key: string,
  value: unknown,
  ts: Timestamp,
): LWWMap {
  return {
    ...map,
    [key]: { value, ts },
  };
}

export function stampLWWMapValue(
  map: LWWMap,
  key: string,
  value: unknown,
  counter: number,
  deviceId: string,
): LWWMap {
  return setLWWMapValue(map, key, value, { counter, device_id: deviceId });
}

export { stampRegister };
